module.exports = __webpack_public_path__ + "static/vmware_28.bf6c4756.jpg";